import * as React from "react";
const SvgTrash = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20 5h-4V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H4v2h16zM10 5V4h4v1z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "currentColor", d: "M19 8H5v11a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3z" })));
export default SvgTrash;
//# sourceMappingURL=Trash.js.map